import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { getFormationById } from "../../../../services/formation.service";
import Checkbox from "../../../../components/Checkbox";


const Row = ({ item, value, onChange, onClick }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };

  const handleRowClick = async () => {
    if (onClick) {
      onClick(item.id);
    }

    try {
      // Récupérer les données complètes de la formation avant de naviguer
      const formationData = await getFormationById(item.id);
      navigate(`/admin/formations/${item.id}`, { state: { formation: formationData } });
    } catch (error) {
      console.error('Erreur lors de la récupération des données de la formation:', error);
      // Naviguer quand même avec les données partielles
      navigate(`/admin/formations/${item.id}`, { state: { formation: item } });
    }
  };

  const handleCheckboxChange = (e) => {
    e.stopPropagation(); // Empêcher la propagation pour éviter de déclencher handleRowClick
    onChange(e.target.checked);
  };

  // Ajouter un Control pour les actions (comme dans le composant Promotion)
  const handleRowContentClick = (e) => {
    // Ne déclencher handleRowClick que si on n'a pas cliqué sur un élément interactif
    if (!e.target.closest(`.${styles.checkbox}`) &&
      !e.target.closest('button')) {
      handleRowClick(e);
    }
  };

  return (
    <>
      <div className={styles.row} onClick={handleRowContentClick} style={{ cursor: 'pointer' }}>
        <div className={styles.col} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            className={styles.checkbox}
            checked={value}
            onChange={handleCheckboxChange}
          />
        </div>

        <div className={styles.col}>
          <div className={styles.item}>
            <div className={styles.avatar}>
              <img src={item.logoUrl || '/images/content/formation_logo.png'} alt="Logo" />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{item.exact_title_of_qualification || 'Sans titre'}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.detail}>{item.rncp_code || 'N/A'}</div>
        </div>

        <div className={styles.col}>
          <div className={styles.detail}>{item.diploma_code || 'N/A'}</div>
        </div>


        <div className={styles.col}>
          <div className={styles.statusGroup}>
            {Array.isArray(item.type_of_contract) && item.type_of_contract.length > 0 ? (
              item.type_of_contract.map((type, index) => {
                // Déterminer la couleur selon le type de contrat
                const getContractColor = (contractType) => {
                  const typeLower = contractType.toLowerCase();
                  switch (typeLower) {
                    case 'apprentissage':
                      return 'status-green-dark';
                    case 'professionnalisation':
                      return 'status-blue-dark';
                    default:
                      return 'status-grey';
                  }
                };

                return (
                  <div 
                    key={`${item.id}-contract-${index}`}
                    className={cn(
                      'status-type',
                      getContractColor(type),
                      styles.contractBadge
                    )}
                  >
                    {type}
                  </div>
                );
              })
            ) : (
              <div className={cn(
                'status-type',
                'status-grey'
              )}>
                N/A
              </div>
            )}
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.statusGroup}>
            {item.status ? (
              (() => {
                // Déterminer la classe CSS selon le statut
                const getStatusClass = (status) => {
                  const statusLower = status.toLowerCase();
                  switch (statusLower) {
                    case 'active':
                      return 'status-green-dark';
                    case 'inactive':
                      return 'status-red-dark';
                    case 'brouillon':
                      return 'status-red-dark';
                    default:
                      return 'status-grey';
                  }
                };

                return (
                  <div 
                    className={cn(
                      'status-type',
                      getStatusClass(item.status),
                      styles.contractBadge
                    )}
                  >
                    {item.status}
                  </div>
                );
              })()
            ) : (
              <div className={cn(
                'status-type',
                'status-grey'
              )}>
                N/A
              </div>
            )}
          </div>
        </div>


    

      </div>
    </>
  );
};

export default Row;